import { PublicRouters } from "../../constant/PublicRouters"

export const checkPublicRouter = () =>
  PublicRouters.includes(window.location.pathname)
